export default "__VITE_ASSET__4cO8DKsA__"